<template>
    <div class="card col" :style="boxShadow">
        <div class="card-body row-wrap">
            <div class="rating-group col">
                <h1>{{ overallRating.toFixed(2) }}</h1>
                <div class="stars">
                    <StarRating :rating="overallRating" :gold="true" />
                    <p>({{ numReviews }} reviews)</p>
                </div>
            </div>
            <div class="bar-group col">
                <div class="rating row" v-for="(review, index) in reviews" :key="index">
                    <p id="category-label">{{ 6 - index }} stars</p>
                    <div class="bar" :style="ratingBar(6 - index)" />
                    <p id="data-label">{{ Math.round((reviews[6 - index] / numReviews) * 100) }}%</p>
                </div>
            </div>
            <div class="col prof-filter">
                <p>
                    <span class="prof-filter-header" v-if="!isMobile">
                        View course rating for:
                    </span>
                    <span class="prof-filter-body" v-on:click="toggleModal">
                        <span class="prof-filter-type"> {{ formattedProfessor }} </span>
                        <i class="fas fa-chevron-down"></i>
                    </span>
                </p>
            </div>
        </div>
        <div class="card-footer" v-if="overallComment">
            <img src="@/assets/icons/other/quote.svg" />
            <p>{{ overallComment }}</p>
        </div>
        <div class="modal" v-bind:class="{ 'is-active': showModal }">
            <div class="modal-background" v-on:click="toggleModal"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Professors</p>
                    <button class="delete" aria-label="close" v-on:click="toggleModal">
                        <img src="@/assets/icons/actions/close-icon.svg" />
                    </button>
                </header>
                <section class="modal-card-body">
                    <ul>
                        <li v-bind:class="{ active: professorFilter === 'all' }">
                            <span v-on:click="updateProfessorFilter"> All professors </span>
                            <span v-if="professorFilter === 'all'">
                                <i class="fas fa-check"></i>
                            </span>
                        </li>
                    </ul>
                    <h4>Individual Professors</h4>
                    <ul>
                        <li
                            v-for="(professor, index) in professors"
                            :key="index"
                            v-bind:class="{ active: professorFilter === professor }"
                        >
                            <span v-on:click="updateProfessorFilter" :profId="index"> {{ professor.name }} </span>
                            <span v-if="professorFilter === professor">
                                <i class="fas fa-check"></i>
                            </span>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import StarRating from "@/components/other/StarRating";

export default {
    name: "CourseSummaryCard",

    props: {
        overallRating: Number,
        overallComment: String,
        numReviews: Number,
        reviews: Object,
        color: String,
        professors: Array,
        professorFilter: String,
        isMobile: Boolean,
    },

    data() {
        return {
            showModal: false,
        };
    },

    updated() {
        // console.log(this.professorFilter);
    },

    created() {
        this.$parent.$on("openModal", this.toggleModal);
    },

    components: {
        StarRating,
    },

    computed: {
        boxShadow() {
            return {
                "--box-color": this.color,
            };
        },
        formattedProfessor() {
            if (this.professorFilter === "all") {
                return "All professors";
            } else {
                return this.professorFilter;
            }
        },
    },

    methods: {
        ratingBar(index) {
            if (this.reviews[index] == 0) {
                return {
                    width: 0,
                    "margin-right": "0px",
                };
            } else {
                return {
                    width: `${174.0 * (this.reviews[index] / this.numReviews)}px`,
                };
            }
        },

        toggleModal() {
            this.showModal = !this.showModal;
        },

        updateProfessorFilter($event) {
            let name = $event.target.innerHTML.trim();
            let profId = $event.target.getAttribute("profId");
            if (name === "All professors") {
                name = "all";
            }

            // Update the name
            this.$emit("updateProfessorFilter", name);
            this.$emit("updateRatings", profId);
            this.showModal = false;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

.card h1 {
    color: #e3c855;
    font-weight: 500;
}

.card p {
    color: $secondary;
}

.card {
    padding: 32px 54px;
    min-width: 300px;
    max-width: 502px;
    width: 100%;

    /* background */
    background: $lighter;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    box-shadow: 0px 13px 9px var(--box-color);
    border-radius: 24px;
}

.card-body {
    justify-content: center;
}

.rating-group {
    align-items: center;
    min-width: fit-content;
    padding-right: 32px;
}

.bar-group {
    flex: 1;
    min-width: max-content;
}

#category-label,
#data-label {
    line-height: 0em;
    margin: 0em;
}

#category-label {
    color: black;
    opacity: 0.3;
}

#data-label {
    color: #e3c855;
}

.rating {
    flex: 1;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
}

.bar {
    background: #e3c855;
    height: 10px;
    width: var(--bar-width);
    border-radius: 2px;
    margin-left: 17px;
    margin-right: 6px;
}

.prof-filter {
    align-items: flex-start;
    display: flex;
    width: 100%;

    p {
        color: $primary;
        margin-top: 16px;
    }

    span.prof-filter-header {
        font-weight: 900;
    }

    span.prof-filter-type {
        margin: 0px 8px;
    }

    span.prof-filter-body:hover {
        cursor: pointer;
    }
}

.card-footer {
    margin-top: 10px;
    display: flex;

    img {
        align-self: flex-start;
    }

    p {
        margin: 0em;
        margin-left: 15px;
        margin-top: -5px;
        color: black;
    }
}

.modal-card {
    padding: 24px 28px;
    border-radius: 12px;

    header.modal-card-head {
        background-color: white;
        border-bottom: none !important;
        padding-bottom: 0;

        p {
            color: black;
        }

        button.delete {
            align-items: center;
            border-radius: 100%;
            background-color: $lighter;
            display: flex;
            height: 33px;
            justify-content: center;
            width: 33px;
        }
    }

    section.modal-card-body {
        padding-top: 0;
        border-radius: 0px 0px 6px 6px;

        > :first-child {
            font-size: 16px;
        }

        > :nth-child(3) {
            margin-top: 0;
        }

        .active {
            color: $primary;
            font-weight: 900;
        }

        h4 {
            color: #999999;
            font-size: 14px;
            text-transform: uppercase;
        }

        li {
            display: inline-block;
            list-style-type: none;
            margin: 10px 0;
            width: 50%;
        }

        span:hover {
            cursor: pointer;
        }

        ul {
            font-size: 14px;
            padding-left: 0;

            .fa-check {
                margin-left: 5px;
            }
        }
    }

    .modal-card-title {
        margin: 0;
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    .rating-group {
        padding-right: 0;
    }
}

@media only screen and (min-width: $breakpoint-medium) {
    .modal-card {
        width: 520px;
    }
}

@media only screen and (max-width: $breakpoint-small) {
    .prof-filter {
        align-items: center;
        background-color: $light;
        border-radius: 99px;
        display: flex;
        margin: 16px 0;

        p {
            margin: 8px;
        }
    }

    .modal-card {
        border-radius: 0;
        max-height: none;
        padding: 0;
        height: 100%;

        section.modal-card-body {
            border-radius: 0px;
        }

        .modal-card-head {
            border-radius: 0px;
        }
    }
}
</style>
